/**
 * 공용 유틸리티 함수
 */

// let log = require("./logger");
const moment = require('moment');
require('moment-timezone');
moment.tz.setDefault('Asia/Seoul');

module.exports.moment = moment;

module.exports.getLocalTime = (unixTime) => {
  return moment(unixTime).format('YYYY. MM. DD HH:mm');
};

module.exports.getLocalOnlyTime = (unixTime) => {
  return moment(unixTime).format('HH:mm');
};

module.exports.numberFormat = (number, decimals, dec_point, thousands_sep) => {
  // http://kevin.vanzonneveld.net
  // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +     bugfix by: Michael White (http://getsprink.com)
  // +     bugfix by: Benjamin Lupton
  // +     bugfix by: Allan Jensen (http://www.winternet.no)
  // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  // +     bugfix by: Howard Yeend
  // +    revised by: Luke Smith (http://lucassmith.name)
  // +     bugfix by: Diogo Resende
  // +     bugfix by: Rival
  // +      input by: Kheang Hok Chin (http://www.distantia.ca/)
  // +   improved by: davook
  // +   improved by: Brett Zamir (http://brett-zamir.me)
  // +      input by: Jay Klehr
  // +   improved by: Brett Zamir (http://brett-zamir.me)
  // +      input by: Amir Habibi (http://www.residence-mixte.com/)
  // +     bugfix by: Brett Zamir (http://brett-zamir.me)
  // +   improved by: Theriault
  // +   improved by: Drew Noakes
  // *     example 1: numberFormat(1234.56);
  // *     returns 1: '1,235'
  // *     example 2: numberFormat(1234.56, 2, ',', ' ');
  // *     returns 2: '1 234,56'
  // *     example 3: numberFormat(1234.5678, 2, '.', '');
  // *     returns 3: '1234.57'
  // *     example 4: numberFormat(67, 2, ',', '.');
  // *     returns 4: '67,00'
  // *     example 5: numberFormat(1000);
  // *     returns 5: '1,000'
  // *     example 6: numberFormat(67.311, 2);
  // *     returns 6: '67.31'
  // *     example 7: numberFormat(1000.55, 1);
  // *     returns 7: '1,000.6'
  // *     example 8: numberFormat(67000, 5, ',', '.');
  // *     returns 8: '67.000,00000'
  // *     example 9: numberFormat(0.9, 0);
  // *     returns 9: '1'
  // *    example 10: numberFormat('1.20', 2);
  // *    returns 10: '1.20'
  // *    example 11: numberFormat('1.20', 4);
  // *    returns 11: '1.2000'
  // *    example 12: numberFormat('1.2000', 3);
  // *    returns 12: '1.200'
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point,
    toFixedFix = function (n, prec) {
      // Fix for IE parseFloat(0.55).toFixed(0) = 0;
      var k = Math.pow(10, prec);
      return Math.round(n * k) / k;
    },
    s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
};

/**
 * 입력날짜에 맞는 요일을 반환한다.
 * @param {*} yyyymmdd 날짜
 * @returns '일','월','화','수','목','금','토'
 */
module.exports.getWeekDay = (yyyymmdd) => {
  let week = ['일', '월', '화', '수', '목', '금', '토'];
  return week[moment(yyyymmdd, 'YYYYMMDD').day()];
};

module.exports.getYYYYMMDD = (s) => {
  if (!s) {
    return moment().format('YYYYMMDD');
  } else {
    return moment().format('YYYYMMDD');
  }
};

/**
 * 금액표시문자열을 반환한다.
 * @param {any} number 금액값. 문자열, 숫자 상관없다.
 * @param {string} currencyType 지원하는 통화. krw, usd 지원
 */
module.exports.getCurrency = (number, currencyType) => {
  if (!currencyType) {
    currencyType = 'krw';
  }
  if (currencyType === 'krw') {
    return module.exports.numberFormat(number);
  } else {
    return module.exports.numberFormat(number, 2, '.', ',');
  }
};

/**
 * 사업자번호 10자리 문자열을 받아 -를 붙여서 반환한다.
 * @param {string} bsnnNo 사업자번호
 */
module.exports.formatBsnnNo = (bsnnNo) => {
  if (typeof bsnnNo !== 'string' && String(bsnnNo).length !== 10) {
    return '';
  }
  return `${bsnnNo.substr(0, 3)}-${bsnnNo.substr(3, 2)}-${bsnnNo.substr(5, 5)}`;
};

/**
 * 휴대전화번호 11자리 문자열을 받아 -를 붙여서 반환한다.
 * @param {string} mobileNo 휴대전화번호
 */
module.exports.formatMobileNo = (mobileNo) => {
  if (typeof mobileNo !== 'string' && String(mobileNo).length !== 11) {
    return mobileNo + '';
  }
  return `${mobileNo.substr(0, 3)}-${mobileNo.substr(3, 4)}-${mobileNo.substr(7, 4)}`;
};

/**
 * 문자열의 한글포함 byte 길이를 반환한다. 단, 한글(3바이트)를 2바이트로 계산한다.
 * @param {string} str 자바스크립트 문자열
 */
module.exports.getByte = (str) => {
  return str
    .split('')
    .map((s) => s.charCodeAt(0))
    .reduce((prev, c) => prev + (c === 10 ? 2 : c >> 7 ? 2 : 1), 0); // 계산식에 관한 설명은 위 블로그에 있습니다.
};

/**
 * 문자열(한글은 2바이트로 계산)을 byte length 만큼 잘라서 반환한다.
 * @param {string} str (한글)문자열
 * @param {int} len 길이
 * @param {boolean} withSpacePadding 공백 패딩여부. default false
 */
const cutByLen = (str, len, withSpacePadding = false) => {
  if (!str) str = '';
  let b, i, c;
  // eslint-disable-next-line no-cond-assign
  for (b = i = 0; (c = str.charCodeAt(i)); ) {
    b += c >> 7 ? 2 : 1;
    if (b > len) break;
    i++;
  }
  let r = str.substring(0, i);
  if (withSpacePadding) r = r + ''.padEnd(len - b, ' ');
  return r;
};
module.exports.cutByLen = cutByLen;

/**
 * 네자리 문자열을 두자리 문자열 배열로 반환한다.
 * @param {string} timeStr      -> '1215'
 * @return {Array} {hour, minute}  -> {hour: '12', minute: '15']
 */
module.exports.splitTime = (timeStr) => {
  if (timeStr && timeStr.length === 4) {
    const hour = timeStr.substr(0, 2);
    const minute = timeStr.substr(2, 2);

    return {
      hour,
      minute,
      second: 0,
    };
  }
};
